module.exports = __webpack_public_path__ + "img/open.33a39e23.png";